import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";

import styles from "./index.module.css";

import {
  EMPTY_GIF,
  VIDEO_RATIO_PC,
  VIDEO_RATIO_MOBILE
} from "../../../constants";
import { sectionScale } from "../../atoms";

const isValidHttpUrl = (string)=> {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

const FullPlayer = ({ result, onReady }) => {
  // width responsive
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.addEventListener("resize", handleCheckWidth, { passive: true });
    return () =>
      window.removeEventListener("resize", handleCheckWidth, { passive: true });
  }, []);

  const handleCheckWidth = () => {
    requestAnimationFrame(() => setWidth(window.innerWidth));
  };

  const isMobile = width < 750;
  // 0.6 is the window size at pc width
  const scaleMultiplier = 1 / sectionScale(width);
  // const vidHeight = isMobile
  //   ? width / VIDEO_RATIO_MOBILE
  //   : ((width * 0.55) / VIDEO_RATIO_PC) * scaleMultiplier;
  // const vidWidth = (width * 0.66 - 120) * scaleMultiplier;

  // loading screen
  const loadingGif = EMPTY_GIF;
  const [ready, setReady] = useState(false);
  const [vidError, setVidError] = useState("");
  // initial url change sets ready to false
  useEffect(() => {
    setVidError("")
    ready && setReady(false);
  }, [result]);
  // this is async, so will always fire after the above useEffect
  const handleReady = () => {
    setReady(true);
    onReady && onReady();
  };

  // hack around react player to solve loading too fast
  // if urls are changed too quickly, url stays empty
  const [url, setUrl] = useState("");
  useEffect(() => {
    setUrl("");

    const t = setTimeout(() => {
      setUrl(result.video_url);
    }, 50);

    return () => clearTimeout(t);
  }, [result]);

  // check for error
  const handleError = e => {
    console.log("handleError:",e.type);
    setVidError(e.type);
  };

  // check existence
  const exists = result.video_url !== undefined;

  if(!isValidHttpUrl(url)) return null

  console.log("vidError:", vidError, "ready;",ready, "url", url);

  // TODO: background size and GIF
  if(vidError === "error") {

    return <div className={styles.noVideoContainer}>
      <a href={url} target="_blank">{url}</a>
    </div>
  }

  return (
    <div className={styles.videoDetailContainer}>
      <div
        style={{
          pointerEvents: "none",
          position: "absolute",
          minHeight: 300,
          minWidth: 300,
          height: "100%",
          width: "100%",
          backgroundImage: ready ? "none" : `url(${loadingGif})`
          // backgroundSize: "100%"
        }}
      />
      <ReactPlayer
        className={styles.videoDetail}
        width="100%"
        height="100%"
        url={url}
        controls={true}
        onReady={handleReady}
        onError={handleError}
      />
    </div>
  );
};

export default FullPlayer;
